(() => {
  if (window.kfCameraStockBound) return;
  window.kfCameraStockBound = true;

  // Use Shopify's native variant selection so checkout enforces component stock.
  document.addEventListener('change', (event) => {
    const choice = event.target.closest('[data-kf-camera-colour-value]');
    if (!choice) return;
    const product = choice.closest('product-info');
    if (!product) return;
    const current = product.querySelector('input[data-kf-stock-colour]:checked');
    if (!current) return;
    const colour = choice.dataset.kfCameraColourValue;
    const cable = current.dataset.kfStockCable;
    const next = product.querySelector(`input[data-kf-stock-colour="${colour}"][data-kf-stock-cable="${cable}"]`);
    if (!next || next === current) return;
    product.querySelectorAll('input[data-kf-stock-colour]').forEach((input) => {
      input.labels.forEach((label) => label.classList.toggle('kf-camera-stock-hidden', input.dataset.kfStockColour !== colour));
    });
    next.checked = true;
    next.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
